import React from "react";
import { ControlLabel, Button, Alert, FormControl, Modal } from "react-bootstrap";
import ajax from "./../lib/ajax.js";
import context from "./../lib/context.js";
import immutable from 'immutable';
import { browserHistory } from "react-router";
import util from "../lib/util.js";

export default class ActivateInactivateUser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            errors: []
        };

        this.activateClick = this.activateClick.bind(this);
        this.loadViewModel = this.loadViewModel.bind(this);
        this.password = null;
        this.retypePassword = null;
    }

    componentWillMount() {
        
    }

    componentDidMount() {
        this.loadViewModel();
    }

    loadViewModel() {
        let self = this;

        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });

        ajax.vm().get(`get-user-for-activation/${self.props.params.token}`)
            .then(function (res) {
                if (res.data.isActivated) {
                    context.message({
                        show: true,
                        type: "info",
                        message: self.getResourceValue("UserAlreadyActivated", res.data.resources),
                        buttons: "close"
                    },
                    function() { 
                        browserHistory.push(context.routeUrl('login')); 
                    });
                }
                else if (res.data.isExpired) {
                    context.message({
                        show: true,
                        type: "info",
                        message: self.getResourceValue("ExpiredActivationToken2", res.data.resources).replace('$VALIDITY_DAYS$', res.data.userActivationDays),
                        buttons: "close"
                    },
                    function() { 
                        browserHistory.push(context.routeUrl('login')); 
                    });
                }
                else {
                    self.setState({
                        data: res.data
                    });
                    context.message({ show: false });
                }
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                },
                function() { 
                    browserHistory.push(context.routeUrl('login')); 
                });
            });
    }

    activateClick() {
        var messages = this.validate();
        
        this.setState({
            errors: messages
        });

        if (messages.length == 0) {
            this.activate();
        }
    }

    activate() {
        let self = this;

        context.message({
            show: true,
            type: "loading",
            message: "Activating. Please wait..."
        });

        ajax.api().post(`activate-inactive-user`,
                {
                    token: self.props.params.token,
                    newPassword: self.password.value
                }
            )
            .then(function (res) {
                if (res.data.isActivated) {
                    context.message({
                        show: true,
                        type: "info",
                        message: self.getResourceValue("UserActivatedSuccessfully"),
                        buttons: "close"
                    },
                    function() {
                        browserHistory.push(context.routeUrl('login'));
                    });
                }
                else if (res.data.errorMessage !== undefined && res.data.errorMessage != '') {
                    let msg = [];
                    msg.push(res.data.errorMessage);
                    self.setState({
                        errors: msg
                    });
                    context.message({ show: false });
                }
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    validate() {
        let msg = [];

        if (this.password.value.length == 0) {
            msg.push(this.getResourceValue("PleaseEnterPassword"));
        }
        else if (this.retypePassword.value.length == 0) {
            msg.push(this.getResourceValue("PleaseRetypePassword"));
        }
        else if (this.password.value != this.retypePassword.value) {
            msg.push(this.getResourceValue("PasswordsDoNotMatch"));
        }
        else if (util.isPasswordValid(this.password.value) == false) {
            msg.push(this.getResourceValue("PasswordRestrictionInvalid"));
        }

        return msg;
    }
    
    getResourceValue(key, resources) {
        if (resources === undefined )
            resources = this.state.data.resources;

        if (resources == null)
            return "";

        var resource = resources.filter(x => x.key == key);

        if (resource.length) return resource[0].value;

        return "";
    }

    render() {
        var rowStyle = {
            "paddingTop" : "10px"
        }

        const self = this;
        return (
            <div>
                <section className="ap-l-section ap-section-hero login">
                    <div className="container">
                        {
                            (self.state.data == null) ? <div></div> : 
                            <div>
                                <div className="row">
                                    <h2 className="text-center">{self.getResourceValue("AccountActivation")}</h2>
                                </div>
                                <div className="row">
                                    <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8" dangerouslySetInnerHTML={ { __html: self.getResourceValue("AccountActivationHeader").replace("$FULL_NAME$", self.state.data.fullName) } }>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="container-fluid col-md-offset-2 col-lg-offset-2 col-md-6 col-lg-6" style={{ "paddingTop" : "10px", "paddingLeft" : "60px" }}>
                                        <div className="row">
                                            <div className="col-md-12 col-lg-12"><ControlLabel className="ap-report-control-label">{self.getResourceValue("LoginID")}:</ControlLabel></div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 col-lg-12">
                                                <FormControl type="text" 
                                                    defaultValue={self.state.data.userName}
                                                    className="login-input"
                                                    readOnly={true}></FormControl>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 col-lg-12"><ControlLabel className="ap-report-control-label">{self.getResourceValue("FirstName")}:</ControlLabel></div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 col-lg-12">
                                                <FormControl type="text" 
                                                    defaultValue={self.state.data.firstName}
                                                    className="login-input"
                                                    readOnly={true}></FormControl>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 col-lg-12"><ControlLabel className="ap-report-control-label">{self.getResourceValue("LastName")}:</ControlLabel></div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 col-lg-12">
                                                <FormControl type="text"
                                                    defaultValue={self.state.data.lastName}
                                                    className="login-input"
                                                    readOnly={true}></FormControl>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 col-lg-12"><ControlLabel className="ap-report-control-label">{self.getResourceValue("JustPassword")}:</ControlLabel></div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 col-lg-12">
                                                <FormControl type="password" placeholder="Password"
                                                    inputRef={ref => this.password = ref}
                                                    className="login-input"></FormControl>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 col-lg-12"><ControlLabel className="ap-report-control-label">{self.getResourceValue("ReEnterPassword")}:</ControlLabel></div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 col-lg-12">
                                                <FormControl type="password" placeholder="Re-enter Password"
                                                    inputRef={ref => this.retypePassword = ref}
                                                    className="login-input"></FormControl>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 col-lg-12">
                                                <Button onClick={self.activateClick} className="btn btn-info ap-fullsize">{self.getResourceValue("ActivateAccount")}</Button>
                                            </div>
                                        </div>
                                        <div className="row" style={rowStyle}>
                                            <div className="col-md-12 col-lg-12">
                                                <Alert bsStyle="danger" className={self.state.errors.length > 0 ? "" : "ap-hidden"}>
                                                    <ul className="text-left">
                                                        {self.state.errors.map(m =>
                                                            <li key={m}>{m}</li>)}
                                                    </ul>
                                                </Alert>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" style={rowStyle}>
                                        <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                                            <p><b><span dangerouslySetInnerHTML={ { __html: self.getResourceValue("AccountActivationFooter") } }></span></b></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </section>
            </div>
        );
    }
}